import React from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';

const WedstrijdenPage = () => {
  const pouleWedstrijden = [
    { date: '14 juni', time: '22:00', home: 'Mexico', away: 'Nederland', stadium: 'SoFi Stadium, LA' },
    { date: '15 juni', time: '01:00', home: 'Ecuador', away: 'Qatar', stadium: 'AT&T Stadium' },
    { date: '20 juni', time: '19:00', home: 'Nederland', away: 'Ecuador', stadium: 'MetLife Stadium' },
    { date: '20 juni', time: '22:00', home: 'Mexico', away: 'Qatar', stadium: 'Rose Bowl' },
    { date: '26 juni', time: '16:00', home: 'Nederland', away: 'Qatar', stadium: 'BC Place' },
    { date: '26 juni', time: '16:00', home: 'Ecuador', away: 'Mexico', stadium: 'SoFi Stadium, LA' }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Wedstrijden</h1>
          <p className="text-xl opacity-90">Complete speelschema's en uitslagen van het WK 2026</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Nederland - Groepsfase</h2>
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <table className="w-full">
              <thead className="bg-amber-100">
                <tr>
                  <th className="px-6 py-4 text-left">Datum</th>
                  <th className="px-6 py-4 text-left">Tijd</th>
                  <th className="px-6 py-4 text-left">Thuisteam</th>
                  <th className="px-6 py-4 text-left">Uitteam</th>
                  <th className="px-6 py-4 text-left">Stadion</th>
                </tr>
              </thead>
              <tbody>
                {pouleWedstrijden.map((match, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <Calendar className="w-4 h-4 mr-2 text-gray-400" />
                        {match.date}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <Clock className="w-4 h-4 mr-2 text-gray-400" />
                        {match.time}
                      </div>
                    </td>
                    <td className="px-6 py-4 font-semibold">{match.home}</td>
                    <td className="px-6 py-4 font-semibold">{match.away}</td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <MapPin className="w-4 h-4 mr-2 text-gray-400" />
                        {match.stadium}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WedstrijdenPage;